var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcActiveDescriptive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2170_1210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 7C2 3.68629 4.68629 1 8 1H36C39.3137 1 42 3.68629 42 7V35C42 38.3137 39.3137 41 36 41H8C4.68629 41 2 38.3137 2 35V7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5H36C39.0376 1.5 41.5 3.96243 41.5 7V35C41.5 38.0376 39.0376 40.5 36 40.5H8C4.96243 40.5 2.5 38.0376 2.5 35V7C2.5 3.96243 4.96243 1.5 8 1.5Z",
    stroke: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2170_1210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8566 28.125C26.7816 28.125 26.7066 28.1025 26.6441 28.06L24.2141 26.385H20.8516C20.2316 26.385 19.7266 25.88 19.7266 25.26V20.99C19.7266 20.7825 19.8941 20.615 20.1016 20.615C20.3091 20.615 20.4766 20.7825 20.4766 20.99V25.26C20.4766 25.4675 20.6441 25.635 20.8516 25.635H24.3316C24.4066 25.635 24.4816 25.6575 24.5441 25.7L26.4816 27.035V26.01C26.4816 25.8025 26.6491 25.635 26.8566 25.635H27.9991C28.2066 25.635 28.3741 25.4675 28.3741 25.26V20.0225C28.3741 19.815 28.2066 19.6475 27.9991 19.6475H25.3991C25.1916 19.6475 25.0241 19.48 25.0241 19.2725C25.0241 19.065 25.1916 18.8975 25.3991 18.8975H27.9991C28.6191 18.8975 29.1241 19.4025 29.1241 20.0225V25.26C29.1241 25.88 28.6191 26.385 27.9991 26.385H27.2316V27.75C27.2316 27.89 27.1541 28.0175 27.0316 28.0825C26.9766 28.1125 26.9166 28.125 26.8566 28.125Z",
    fill: "#092E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5924 24.78C25.4474 24.78 25.3074 24.695 25.2474 24.5525L24.4274 22.6325L23.6074 24.5525C23.5249 24.7425 23.3049 24.8325 23.1149 24.75C22.9249 24.6675 22.8349 24.4475 22.9174 24.2575L24.0824 21.5275C24.1424 21.39 24.2774 21.3 24.4274 21.3C24.5774 21.3 24.7124 21.39 24.7724 21.5275L25.9374 24.2575C26.0199 24.4475 25.9299 24.6675 25.7399 24.75C25.6924 24.77 25.6424 24.78 25.5924 24.78Z",
    fill: "#092E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2895 24.0725H23.5645C23.357 24.0725 23.1895 23.905 23.1895 23.6975C23.1895 23.49 23.357 23.3225 23.5645 23.3225H25.2895C25.497 23.3225 25.6645 23.49 25.6645 23.6975C25.6645 23.905 25.497 24.0725 25.2895 24.0725Z",
    fill: "#092E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7202 17.6201C20.7202 17.8001 20.6777 17.9676 20.6027 18.1201L20.4327 17.9501C20.2877 17.8026 20.0502 17.8026 19.9027 17.9501C19.7577 18.0951 19.7577 18.3326 19.9027 18.4801L20.0727 18.6501C19.9227 18.7226 19.7527 18.7651 19.5752 18.7651C18.9427 18.7651 18.4277 18.2501 18.4277 17.6201C18.4277 16.9901 18.9427 16.4751 19.5752 16.4751C20.2077 16.4751 20.7202 16.9876 20.7202 17.6201Z",
    fill: "#092E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1475 13.875H16C15.38 13.875 14.875 14.38 14.875 15V20.24C14.875 20.86 15.38 21.365 16 21.365H16.7675V22.73C16.7675 22.8675 16.845 22.995 16.97 23.06C17.025 23.09 17.085 23.105 17.1425 23.105C17.2175 23.105 17.2925 23.0825 17.3575 23.0375L19.7825 21.365H23.1475C23.7675 21.365 24.2725 20.86 24.2725 20.24V15C24.2725 14.38 23.7675 13.875 23.1475 13.875ZM21.6225 19.6675C21.55 19.7425 21.4525 19.7775 21.3575 19.7775C21.2625 19.7775 21.165 19.7425 21.0925 19.6675L20.62 19.1975C20.32 19.4 19.96 19.515 19.575 19.515C18.53 19.515 17.6775 18.665 17.6775 17.62C17.6775 16.575 18.53 15.725 19.575 15.725C20.62 15.725 21.47 16.575 21.47 17.62C21.47 18.0075 21.3525 18.3675 21.1525 18.6675L21.6225 19.1375C21.77 19.285 21.77 19.5225 21.6225 19.6675Z",
    fill: "#092E5E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2170_1210",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2170_1210"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2170_1210",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2170_1210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(14 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActiveDescriptive);
export default __webpack_public_path__ + "static/media/ic_active_descriptive.429788e894561727ca8b7fb43b520435.svg";
export { ForwardRef as ReactComponent };